module.exports = __webpack_public_path__ + "img/product_98.bd2a535.webp";